import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Headline = styled.h1(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    fontSize: defaultTheme.font.size.xl,
    fontWeight: 'bold',
    color: defaultTheme.text.default,
    padding: [
      `${defaultTheme.spacing.s} 0 ${defaultTheme.spacing.l}`,
      `${defaultTheme.spacing.s} 0 ${defaultTheme.spacing.l}`,
      `0 0 ${defaultTheme.spacing.xxl}`,
      `0 0 ${defaultTheme.spacing.xxl}`,
    ],
    margin: 0,
  }),
);
